import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import en from '../translations/en';
import de from '../translations/de';

const LanguageContext = createContext();

const translations = {
    en,
    de
};

export const LanguageProvider = ({ children }) => {
    // Initialize state from localStorage if available, otherwise default to 'de'
    const [language, setLanguageState] = useState(() => {
        return localStorage.getItem('language') || 'de';
    });

    const setLanguage = useCallback((lang) => {
        setLanguageState(lang);
        localStorage.setItem('language', lang);
    }, []);

    useEffect(() => {
        document.title = translations[language]?.meta?.title || 'RetterPlus';
        document.documentElement.lang = language;
    }, [language]);

    useEffect(() => {
        const storedLanguage = localStorage.getItem('language');
        const isCrawler = /bot|crawl|spider|slurp|bing|google|duckduck|baidu|yandex|gpt|claude|perplexity|preview|lighthouse/i.test(navigator.userAgent);
        if (!storedLanguage && !isCrawler) {
            const fetchCountry = async () => {
                try {
                    const controller = new AbortController();
                    const timeoutId = setTimeout(() => controller.abort(), 10000);

                    const response = await fetch('https://free.freeipapi.com/api/json', {
                        signal: controller.signal
                    });
                    clearTimeout(timeoutId);

                    if (response.ok) {
                        const data = await response.json();
                        // Check if user has already selected a language while API was fetching
                        if (localStorage.getItem('language')) {
                            return;
                        }

                        let detectedLanguage = 'de';
                        if (data.countryCode !== 'DE' && data.countryCode !== 'AT' && data.countryCode !== 'CH') {
                            detectedLanguage = 'en';
                        }
                        setLanguage(detectedLanguage);
                    }
                } catch (error) {
                    console.error('Failed to fetch language:', error);
                    // Stay with default 'de' and do not set localStorage
                }
            };
            fetchCountry();
        }
    }, [setLanguage]);

    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];
        for (const k of keys) {
            value = value?.[k];
        }
        return value || key;
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
